const navigationCustomCss = (css: string, uniqueSelector: string) => {
  let styles = '';
  let find = /.C-header-menu /g;
  styles = css.replace(new RegExp(find), `${uniqueSelector}.C-header-menu `);

  find = /.C-header-menu__/g;
  styles = css.replace(new RegExp(find), `${uniqueSelector} .C-header-menu__`);

  return styles;
};

export default navigationCustomCss;
